export enum RewardsResourcePath {
	CatalogsAllowanceBoost = 'catalogs/allowance_boost',
	CompanyItemCategories = 'company_item_categories',
	CompanyItems = 'company_items',
	CurrencyConversionRate = 'conversion_rates',
	ResendGiftEmail = '/rewards/{id}/resend_gift_email',
	Rewards = 'rewards',
	RewardsHistory = 'company/rewards/my_rewards',
	UsersRedemptions = 'redemptions',
}
